import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

interface LoginResponse {
  login_key?: string;
  error?: {
    type?: string;
    message?: string;
  };
}

interface LogoutResponse {
  success?: boolean;
  error?: {
    message?: string;
  };
}

export async function login(
  username: string,
  password: string,
  keepAlive: boolean = false,
) {
  const data = {
    username,
    password,
    app_name: 'TocGuest-PWA',
    app_version: '1.0.0',
    keep_alive: keepAlive,
  };

  return post<LoginResponse>(API_ENDPOINTS.LOGIN, data);
}

export async function logout(loginKey: string) {
  return post<LogoutResponse>(API_ENDPOINTS.LOGOUT, { login_key: loginKey });
}

export default {
  login,
  logout,
};
